var exports = {
  "o5": "xa15a2ab7--2243d1--content-wrapper",
  "HE": "xa15a2ab7--2243d1--button-wrapper",
  "aw": "xa15a2ab7--2243d1--semi-transparent",
  "Sl": "xa15a2ab7--2243d1--image",
  "W4": "xa15a2ab7--2243d1--text-wrapper",
};

module.exports = exports;
